const runtimeConfig = window.__APP_CONFIG__ ?? {};

export function getConfig(name, fallback) {
  return runtimeConfig[name] ?? fallback ?? '';
}
